<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card">
          <ValidationObserver v-slot="{ passes }">
            <div class="header">
              <h2>Edit User</h2>
            </div>
            <div class="body">
              <form @submit.prevent="passes(userSubmitData)" id="basic-form">
                <div class="row">
                  <div class="col-12">
                    <ValidationProvider
                      name="select_country"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div class="country-dropdown">
                        <div
                          class="form-group form-select multiselect-grp"
                          :class="{
                            errors: errors[0],
                            success:
                              user.country &&
                              user.country.length != 0 &&
                              !errors[0],
                          }"
                        >
                          <span class="float-label">
                            <label for="Country">Select Country*</label>
                            <multiselect
                              placeholder=""
                              v-model="user.country"
                              :show-labels="false"
                              :options="countryList"
                              label="name"
                              track-by="name"
                              @select="setPrimaryNumberCountryCode"
                            >
                              <template slot="option" slot-scope="props">
                                <span
                                  :class="
                                    'flag-icon flag-icon-' +
                                    props.option.isoCode.toLowerCase() +
                                    ' fi-md fi-round '
                                  "
                                ></span>
                                <div class="option__desc">
                                  <span class="option__title">
                                    {{ props.option.name }}
                                  </span>
                                </div>
                              </template>
                            </multiselect>
                            <i
                              class="fa fa-times"
                              v-if="errors.length && errors[0]"
                            ></i>
                            <i
                              class="fa fa-check"
                              v-if="
                                user.country &&
                                user.country.length != 0 &&
                                !errors[0]
                              "
                            ></i>
                          </span>
                        </div>
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6 col-12">
                    <ValidationProvider
                      name="first_name"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !user.first_name,
                          success: user.first_name,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="user.first_name"
                            class="form-control"
                            id="first_name"
                            placeholder="First Name*"
                          />
                          <label for="first_name" class="control-label">
                            First Name*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !user.first_name"
                          ></i>
                          <i class="fa fa-check" v-if="user.first_name"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6 col-12">
                    <ValidationProvider
                      name="last_name"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !user.last_name,
                          success: user.last_name,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="user.last_name"
                            class="form-control"
                            id="last_name"
                            placeholder="Last Name*"
                          />
                          <label for="last_name" class="control-label">
                            Last Name*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !user.last_name"
                          ></i>
                          <i class="fa fa-check" v-if="user.last_name"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6 col-12">
                    <ValidationProvider
                      name="contact_email"
                      rules="required|email"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors:
                            (errors.length && !user.contact_email) || errors[0],
                          success: user.contact_email && !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="email"
                            v-model="user.contact_email"
                            class="form-control"
                            name="email1"
                            id="contact_email"
                            placeholder="Contact Email Address*"
                          />
                          <label for="contact_email" class="control-label">
                            Contact Email Address*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="
                              (errors.length && !user.contact_email) ||
                              errors[0]
                            "
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="user.contact_email && !errors[0]"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6 col-12">
                    <ValidationProvider
                      name="mobile_number"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: mobileInputError == false,
                          success: user.mobile_number && mobileInputError,
                        }"
                      >
                        <div class="float-label">
                          <label for="mobile_number" class="control-label">
                            Contact Mobile Number*
                          </label>
                          <vue-tel-input
                            v-model="user.mobile_number"
                            v-bind="primaryMobileNumber"
                            @validate="mobileInputValidate"
                            ref="telInput"
                            @keydown.native="restrictSpecialCharacter($event)"
                          >
                            <template v-slot:arrow-icon>
                              <span class="vti__dropdown-arrow">{{ "▼" }}</span>
                            </template>
                          </vue-tel-input>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="mobileInputError == false"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="mobileInputError && user.mobile_number"
                          ></i>
                        </div>
                        <span
                          class="text-danger error-msg"
                          v-if="errors && isDisplayPhoneError && user.country"
                        >
                          {{ errors[0] }}
                        </span>
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="col-12">
                    <ValidationProvider
                      name="roles"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success: user.role && user.role && !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="roles">Select Roles*</label>
                          <multiselect
                            placeholder=""
                            v-model="user.role"
                            :show-labels="false"
                            :searchable="false"
                            :options="roles_options"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="user.role && user.role && !errors[0]"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div class="form-group" v-if="user.role">
                      <label class="font-weight-bold">Permissions:</label>
                      <div class="pl-5">
                        <div
                          class="checkbox-wrapper d-flex row"
                          v-for="(item, index) in premissions"
                          :key="index"
                        >
                          <label class="mr-2 col-2">{{ item.name }}</label>
                          <label class="fancy-checkbox element-left col-2">
                            <input
                              type="checkbox"
                              name="readonly"
                              v-model="item.options.readonly"
                              @click="check(index, 'readonly')"
                            />
                            <span>Read</span>
                          </label>
                          <label class="fancy-checkbox element-left col-2">
                            <input
                              type="checkbox"
                              name="readWrite"
                              v-model="item.options.readWrite"
                              @click="check(index, 'readWrite')"
                            />
                            <span>Read & Write</span>
                          </label>
                          <label class="fancy-checkbox element-left col-2">
                            <input
                              type="checkbox"
                              name="readWrite"
                              v-model="item.options.delete"
                            />
                            <span>Delete</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$router.back()"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                    @click="isDisplayPhoneError = true"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const { ValidationObserver, ValidationProvider } = require("vee-validate");
const { VueTelInput } = require("vue-tel-input");
import { mapState, mapGetters } from "vuex";
export default {
  name: "AddUserComponent",
  components: {
    ValidationObserver,
    ValidationProvider,
    Multiselect: () => import("vue-multiselect"),
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    VueTelInput,
  },
  data: () => ({
    roles_options: ["Owner", "Admin", "Manager", "User"],
    user: {
      first_name: "Jack",
      last_name: "Dawson",
      country: {
        flagClass: "flag-icon flag-icon-us fi-lg fi-round",
        isoCode: "us",
        name: "United States",
      },
      contact_email: "jackdawson@yopmail.com",
      mobile_number: "7854854854",
      role: "Admin",
    },

    isDisplayPhoneError: false,
    mobileInputError: "",
    primaryMobileNumber: {
      mode: "auto",
      defaultCountry: "gb",
      autoFormat: false,
      dropdownOptions: {
        showFlags: true,
        disabled: true,
        showDialCodeInSelection: true,
      },
    },
    premissions: [
      {
        name: "Dashboard",
        options: {
          readonly: true,
          readWrite: false,
          delete: true,
        },
      },
      {
        name: "Listing",
        options: {
          readonly: true,
          readWrite: true,
          delete: false,
        },
      },
      {
        name: "Transaction list",
        options: {
          readonly: true,
          readWrite: false,
          delete: false,
        },
      },
      {
        name: "Customer",
        options: {
          readonly: false,
          readWrite: true,
          delete: false,
        },
      },
      {
        name: "Partner",
        options: {
          readonly: false,
          readWrite: false,
          delete: false,
        },
      },
    ],
  }),
  methods: {
    userSubmitData() {
      console.log("Submited");
    },
    check(index, type) {
      if (type == "readWrite") {
        this.premissions[index].options.readonly = false;
      }
      if (type == "readonly") {
        this.premissions[index].options.readWrite = false;
      }
    },
    setPrimaryNumberCountryCode(defaultCountry) {
      this.$refs.telInput.choose(defaultCountry.isocode);
    },
    mobileInputValidate(phoneObject) {
      this.mobileInputError = phoneObject.valid;
    },
    restrictSpecialCharacter(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },
  },
  computed: {
    ...mapGetters(["isLoading", "countryList"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
